import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { HttpError } from '@/api/http'

import { redeemAccessCode } from './services'
import { RedeemAccessCodePayload, RedeemAccessCodeResponse } from './types'

export const useMutationRedeemAccessCode = (
  options?: Omit<UseMutationOptions<RedeemAccessCodeResponse, HttpError, RedeemAccessCodePayload>, 'mutationFn'>
) => {
  return useMutation({
    mutationFn: redeemAccessCode,
    ...options,
  })
}
